import ApiService from '@/services/api.service'

const HistoryService = {

	/**
	 * Retourne l'historique entre deux dates
	 */
	getHistory: async function(dateRange,page,elements) {
		const response = await ApiService.get('/api/history?start='+ dateRange[0] + '&end=' + dateRange[1]  + '&page=' + page  + '&elements=' + elements )
		return response.data
	},


	countHistoryElements: async function(dateRange) {
		const response = await ApiService.get('/api/history/page?start='+ dateRange[0] + '&end=' + dateRange[1] )
		return response.data
	}
}

export default HistoryService